import { useFeatures } from '@/hooks/api/useFeatures';
import { Channels } from '@/components/features/top/Channels';
import { Features } from '@/components/features/top/Features';
import { Menu } from '@/components/layout/Menu';
import { AppLayout } from '@/components/layout/AppLayout';
import { Playlists } from '@/components/features/top/Playlists';
import { Helmet } from 'react-helmet-async';
import { useAdBanners } from '@/hooks/api/useAdBanners';
import { isDesktop, isMobile, isTablet } from 'react-device-detect';
import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { AdBanner } from '@/models';

export const Top = () => {
  const { data: features } = useFeatures();
  const { data: ad_banners } = useAdBanners();

  const [adBanner, setAdBanner] = useState<AdBanner | null>();

  useEffect(() => {
    if (ad_banners) {
      const ad_banner = ad_banners.find((ad_banner) => ad_banner.display_target === 'sp');
      setAdBanner(ad_banner);
    }
  }, [ad_banners]);

  return (
    <AppLayout type={'top'}>
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: 'ヘブンTV',
            alternateName: ['ヘブンTV'],
            url: 'https://cityheaven-tv.knip.jp/',
          })}
        </script>
      </Helmet>

      <section className="kv ch">
        <div className="img p1">
          <div className="ch-logo-wrapper">{/*<div className="ch-logo" aria-label="City Heaven TV"></div>*/}</div>
        </div>
      </section>

      <div className="global-container">
        <Menu />

        <div className="content-main top">
          <Channels />
          <Playlists />

          {/*{isMobile && (*/}
          {/*  <div className="iframe-wrap">*/}
          {/*    <iframe*/}
          {/*      src="https://www.cityheaven.net/tokyo/diarytop/netatop/neta-46969/?heaventv&pcmode=sp"*/}
          {/*      frameBorder="0"*/}
          {/*    ></iframe>*/}
          {/*  </div>*/}
          {/*)}*/}

          <Features />

          {(isMobile || isTablet) && (
            <section className="body-banner">
              {adBanner != null && (
                <Link
                  key={`ab-${adBanner.id}`}
                  to={adBanner.url}
                  className="banner ad-banner"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-ad-banner-click={`ad_banner_click:${adBanner.id}`}
                  data-ad-banner-display={`ad_banner_display:${adBanner.id}`}
                >
                  <img src={adBanner.content_url} data-ad-banner-click={`ad_banner_click:${adBanner.id}`} />
                </Link>
              )}
            </section>
          )}
        </div>
      </div>
    </AppLayout>
  );
};
